import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import genericErrorIcon from '../assets/images/icon-generic-error.svg';

import Page from './Page';

const Error = ({ title, message, icon, redirectText, redirectTo }) => {
  return (
    <Page>
      <div className="inset-0 pt-12 flex flex-col justify-center items-center">
        <img className="mb-4" width="100" height="100" src={icon} alt="Immagine di errore" />
        <h1 className="text-center font-serif font-black text-3xl tracking-tight block text-black mb-2">{ title }</h1>
        <p className="text-center">{ message }</p>
        <Link 
          className="appearance-none w-full md:w-auto focus:outline-none focus:shadow border border-gray-600 bg-gray-600 text-white hover:bg-white hover:text-gray-600 flex justify-center items-center rounded-full px-12 py-2 mt-8"
          to={redirectTo}>
          { redirectText }
        </Link>
      </div>
    </Page>
  );
};

Error.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  icon: PropTypes.string,
};

Error.defaultProps = {
  title: 'Ops... Qualcosa è andato storto.',
  message: 'Ricarica la pagina o torna più tardi.',
  icon: genericErrorIcon,
  redirectText: 'Torna alla home',
  redirectTo: '/',
};

export default Error;